const frames = require('./frames');
const symbols = require('./symbols');

const circleSymbolAttributes = { class: 'circle-symbol', transform: 'translate(6.6 6.6) scale(0.45)' };
const badgeSymbolAttributes = { class: 'badge-symbol', transform: 'translate(15.5 15.5) scale(0.25)' };
const cautionBadgeSymbolAttributes = { class: 'caution-badge-symbol', transform: 'translate(15.5 17) scale(0.2)' };
const signSymbolAttributes = { class: 'caution-sign-symbol', transform: 'translate(6.6 9) scale(0.45)' };
const shieldSymbolAttributes = { class: 'shield-symbol', transform: 'translate(6 6) scale(0.5)' };
const pageSymbolAttributes = { class: 'page-symbol', transform: 'translate(6 8) scale(0.5)' };
const pageCenterSymbolAttributes = { class: 'page-center-symbol', transform: 'translate(4.6 8) scale(0.3)' };
const pageCornerSymbolAttributes = { class: 'page-corner-symbol', transform: 'translate(11 11) scale(0.54)' };

const Icons = {
  icon: function(name, attributes) {
    return svg(attributes, [
      symbol(name)
    ]);
  },

  iconWithBadge: function(name, badgeName, attributes) {
    return svg(attributes, [
      symbol(name),
      frames.badge,
      group(badgeSymbolAttributes, [
        symbol(badgeName)
      ])
    ]);
  },

  iconWithCautionBadge: function(name, badgeName, attributes) {
    return svg(attributes, [
      symbol(name),
      frames['caution-badge'],
      group(cautionBadgeSymbolAttributes, [
        symbol(badgeName)
      ])
    ]);
  },

  iconCircle: function(name, attributes) {
    return svg(attributes, [
      frames.circle,
      group(circleSymbolAttributes, [
        symbol(name)
      ])
    ]);
  },

  iconCircleWithBadge: function(name, badgeName, attributes) {
    return svg(attributes, [
      frames.circle,
      group(circleSymbolAttributes, [
        symbol(name)
      ]),
      frames.badge,
      group(badgeSymbolAttributes, [
        symbol(badgeName)
      ])
    ]);
  },

  iconPage: function(name, attributes) {
    return svg(attributes, [
      frames.page,
      group(pageSymbolAttributes, [
        symbol(name)
      ])
    ]);
  },

  iconPageWithCorner: function(centerName, cornerName, attributes) {
    return svg(attributes, [
      frames['page-with-corner'],
      group(pageCenterSymbolAttributes, [
        symbol(centerName)
      ]),
      group(pageCornerSymbolAttributes, [
        symbol(cornerName)
      ])
    ]);
  },

  iconCautionSign: function(name, attributes) {
    return svg(attributes, [
      frames['caution-sign'],
      group(signSymbolAttributes, [
        symbol(name)
      ])
    ]);
  },

  iconShield: function(name, attributes) {
    return svg(attributes, [
      frames.shield,
      group(shieldSymbolAttributes, [
        symbol(name)
      ])
    ]);
  },

  allSymbols: Object.keys(symbols),

  allVariations: function() {
    return Object.keys(this).filter( function(el) {
      return (el !== "allSymbols") && (el !== "allVariations");
    }).map(ccToSnake);
  }
}

function ccToSnake(str) {
  return str.
    replace(/^[A-Z]/g, function($1) { return $1.toLowerCase(); }).
    replace(/[A-Z]/g, function($1) { return "-" + $1.toLowerCase(); });
}

function symbol(name) {
  return symbols[name];
}

function svg(attributes, children) {
  const attrs = Object.assign(attributes, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '-1 -1 26 26' });
  return tag('svg', attrs, children);
}

function group(attributes, children) {
  return tag('g', attributes, children);
}

function tag(name, attributes, children) {
  const attrString = objectToAttributes(attributes);
  const contents = children.join('');
  return stripNewlines('<' + name + attrString + '>' + contents + '</' + name + '>');
}

function stripNewlines(string) {
  return string.replace(/\n|\r/g, '');
}

function objectToAttributes(obj) {
  return Object.keys(obj).reduce(function(prevVal, curVal) {
    return prevVal + ' ' + curVal + '="' + obj[curVal] + '"';
  }, '');
}

module.exports = Icons;



//////////////////
// WEBPACK FOOTER
// ./~/ferrous/source/components/icons/icons.js
// module id = 512
// module chunks = 1 4